import { render, staticRenderFns } from "./ExchangeDetailsOffer.vue?vue&type=template&id=f9765096&"
import script from "./ExchangeDetailsOffer.vue?vue&type=script&lang=js&"
export * from "./ExchangeDetailsOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports